import React from 'react';
import { FaVault, FaCloud } from 'react-icons/fa6';
import { colors } from '../../foundations';
const CloudVaultIcon = () => {
    return (React.createElement("div", { style: { display: 'flex', justifyContent: 'center', alignItems: 'center' } },
        React.createElement(FaCloud, { size: 30, color: colors.black }),
        React.createElement(FaVault, { size: 12, color: '#ffffff', style: { position: 'absolute', marginTop: 4 } })));
};
export default CloudVaultIcon;
